import { Viewer } from '@photo-sphere-viewer/core';

$(document).ready(function () {

    let viewerDiv = $(".panoroma-viewer");
    if (!viewerDiv.length) return;
    else {
        let filters = {};
        viewerDiv.each(function () {
            let id = $(this).data('guid');
            if (id) {
                filters.image = $("#panoroma-viewer-" + id).data("image");
                filters.caption = $("#panoroma-viewer-" + id).data("caption");

                const viewer = new Viewer({
                    container: 'panoroma-viewer-' + id,
                    panorama: filters.image,
                    caption: filters.caption,
                    touchmoveTwoFingers: true,
                    mousewheelCtrlKey: true,
                });

                $(".psv-download-button").hide();
            }
        });
    };
});
